export class AttachmentConstants {
    static readonly MAXIMUM_DESCRIPTION_LENGTH = 60;
    static readonly MAXIMUM_FILENAME_DISPLAY_LENGTH = 40;
}
